var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" 在线办公 ")]),_c('div',{staticClass:"list-item"})])
}]

export { render, staticRenderFns }